import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const IconWrapper = styled("div")`
    height: 1.5rem;
    width: 1.5rem;
    img {
        cursor: default;
    }

    .default {
        fill: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.iconColor};
    }

    padding-left: 1.375rem;

    @media (max-width: ${breakpoints.values.sm}px) {
        padding-left: 0.625rem;
    }
`
